// Where the legal documents live, shared by the page footer and the signup chat's
// consent line so they cannot point at different places.
export const PRIVACY_URL = 'https://www.pertento.ai/privacy-policy';
export const TERMS_URL = 'https://www.pertento.ai/terms-and-conditions';

// What the signup chat's consent bubble says, written out so the typing indicator can
// be timed from its length like any other message.
export const CONSENT_TEXT = 'By creating an account you approve our Terms of Service and Privacy Policy.';
